<template>
  <div class="detail-pop" :style="{ width: popWidth, height: popHeight }">
    <div class="detail-pop-header">
      <div class="detail-pop-header-title">{{ title }}</div>
      <div class="detail-pop-header-close" @click="onClose">
        <i class="iconfont icon-guanbi2"></i>
      </div>
    </div>
    <div class="detail-pop-center">
      <div
        class="detail-pop-content"
        v-for="(item, index) in info"
        :key="index"
      >
        <div class="detail-pop-content-title">{{ item.headerTitle }}</div>
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col
              :span="colProportion"
              class="detail-pop-content-box-col"
              v-for="(infoItem, infoIndex) in item.list"
              :key="infoIndex"
            >
              <el-col :span="labelProportion">{{ infoItem.label }}</el-col>
              <el-col :span="valueProportion" v-show="!infoItem.isImg">{{
                infoItem.value
              }}</el-col>
              <el-col :span="valueProportion" v-show="infoItem.isImg">
                <div v-for="(img, imgIndex) in infoItem.value" :key="imgIndex">
                  <img :src="img" alt="" style="width: 75px; height: 75px" />
                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "detail-pop",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    popHeight: {
      type: String,
      default: "400px",
    },
    popWidth: {
      type: String,
      default: "600px",
    },
    colProportion: {
      type: Number,
      default: 12,
    },
    labelProportion: {
      type: Number,
      default: 10,
    },
    valueProportion: {
      type: Number,
      default: 14,
    },
    info: {
      type: Array,
      default: () => {
        return [
          {
            headerTitle: "批准范围",
            list: [
              { label: "园区名称：", value: "测试测试测试" },
              {
                label: "园区名称：",
                value: "测试测试测试",
              },
              { label: "园区名称：", value: "测试测试测试" },
            ],
          },
          {
            headerTitle: "批准范围",
            list: [
              { label: "园区名称：", value: "测试测试测试" },
              {
                label: "园区名称：",
                value: "测试测试测试1111111111111111111111111111111111",
              },
              { label: "园区名称：", value: "测试测试测试" },
            ],
          },
          {
            headerTitle: "实际范围",
            list: [
              { label: "园区名称：", value: "测试测试测试" },
              {
                label: "园区名称：",
                value: "测试测试测试1111111111111111111111111111111111",
              },
              {
                label: "园区名称：",
                isImg: true,
                value: [
                  "http://192.168.1.171:8080/file-system/file/manage/getFile/0d0bffe7728f4306abb816f25456cc88",
                ],
              },
            ],
          },
        ];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    onClose() {
      this.$emit("onClose", false);
    },
  },
};
</script>
<style scoped>
.detail-pop {
  background: rgb(16, 86, 112, 0.8);
  border: 1px solid #05f6fa;
  border-image: linear-gradient(#2a7b95, #2bffff) 30 30;
}
.detail-pop-header {
  color: #fff;
  font-size: 1rem;
  padding: 7px 29px;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.detail-pop-header-title {
  font-weight: bolder !important;
  background: linear-gradient(to bottom, #ffffff, #28ffff);
  -webkit-background-clip: text;
  color: transparent;
}
.detail-pop-header-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 26px;
  height: 26px;
  background: rgb(89 197 222 / 62%);
  border-radius: 0 0 0 50px;
  text-align: center;
  color: #013f52;
  font-weight: 600;
  cursor: pointer;
}
.detail-pop-center {
  height: calc(100% - 34px);
  overflow: auto;
}
.detail-pop-content {
  margin: 10px 15px;
  color: #fff;
}
.detail-pop-content-title {
  padding: 2px 15px;
  background: #185c75;
  font-size: 0.85rem;
  font-weight: 600;
}
.detail-pop-content-box {
  font-size: 0.8rem;
}
.detail-pop-content-box-col {
  padding: 10px 0;
  word-break: break-all;
}
</style>
